import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { firebase as fb, helpers } from 'redux-firebasev3';
import sortBy from 'lodash/sortBy';

import StatusListItem from '../../containers/StatusListItem';
import { statusesPath } from '../../utils/firebasePaths';

const { dataToJS } = helpers;

@fb(({ channelId, teamId }) => [
  `${statusesPath({ channelId, teamId })}#limitToLast=1`
])
@connect(
  ({ firebase }, { channelId, teamId }) => ({
    statuses: dataToJS(firebase, statusesPath({ channelId, teamId })),
  })
)
export default class ChannelListItemStatus extends Component {
  static propTypes = {
    channelId: PropTypes.string.isRequired,
    statuses: PropTypes.object,
    teamId: PropTypes.string.isRequired,
  }

  render() {
    const { channelId, statuses, teamId } = this.props;

    if (!statuses) {
      return <div />;
    }

    // More than one status can be loaded, so we must ensure the latest is used.
    const statusesArray = Object.keys(statuses).map(k => (
      { ...statuses[k], id: k }
    ));
    const sortedStatuses = sortBy(statusesArray, ['createdAt']);
    const lastStatus = sortedStatuses.reverse()[0];

    return (
      <StatusListItem
        channelId={channelId}
        status={lastStatus}
        teamId={teamId}
      />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/ChannelListItemStatus/index.jsx
 **/